import { cn } from '@/lib/utils'

/** Interruptor liga/desliga com rótulo opcional à direita. */
export function Switch({ checked, onChange, label, title, className }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={cn('flex items-center gap-2', className)}
      title={title}
    >
      <span
        className={cn(
          'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors',
          checked ? 'bg-primary' : 'bg-border'
        )}
      >
        <span
          className={cn(
            'inline-block h-5 w-5 transform rounded-full bg-background shadow transition-transform',
            checked ? 'translate-x-5' : 'translate-x-0.5'
          )}
        />
      </span>
      {label && <span className="text-sm">{label}</span>}
    </button>
  )
}
